Greenmile.MassiveSmartGeocode = Greenmile.MassiveSmartGeocode || {};

Greenmile.MassiveSmartGeocode.AcceptAll = (function () {

    AcceptAll.prototype = new Monet.Grid.ActionsModules.ButtonEventCheckBox();

    function AcceptAll () {

        this.setValueBtn = function () {
            this.valueBtn = Monet.I18n.getResourcesByKey("SmartGeocode.grid.acceptAll");
        };

        this.actionAfterClickButton = function () {

            try {
                const view = App.Views.MassiveSmartGeocode;
                const data = Greenmile.MassiveSmartGeocode.data;

                if (data && data.size() > 0) {

                    const confirmAcceptAll = () => {
                        view.showLoadingAndDisableButtons();

                        const successCallback = () => {
                            view.hideLoadingAndEnableButtons() && App.Views.MassiveSmartGeocode.showGrid();
                        };

                        const errorCallback = () => {
                            view.hideLoadingAndEnableButtons();
                        };

                        const router = new App.Routers.MassiveSmartGeocode();
                        router.acceptAll(successCallback, errorCallback);
                    };

                    new Greenmile.Components.AlertModal("SmartGeocode.grid.confirmAcceptAll",
                        null,
                        confirmAcceptAll)
                    .show();

                } else {
                    new Greenmile.Components.AlertModal("SmartGeocode.grid.noSuggestionFound")
                        .show();
                }

            } catch (e) {

                const error = new Monet.Exception.ReturnError(this, "Error on action after click button on accept all.", e);
                error.console();

            }

        };

        this.initialize = function (entity) {
            this.setEntity(entity);
            this.setSelector("#SmartGeocode .gridActions .grid_header__rigth");
            this.setScreenName("#SmartGeocode");
            this.setValueBtn();
            this.setId("btnAcceptAll");
            this.setBtnSelector('#SmartGeocode #btnAcceptAll');
            this.init();
        };

    }

    return AcceptAll;

})();
